import React from 'react'
import { connect } from 'react-redux'
import { Stepper, Step, StepLabel, withStyles } from '@material-ui/core'

const StepperComponent = ({ activeStep, steps, classes }) => (
  <Stepper
    classes={{ root: classes.root }}
    activeStep={activeStep}
    alternativeLabel
  >
    {steps.map((label) => (
      <Step key={label}>
        <StepLabel classes={{ alternativeLabel: classes.alternativeLabel }}>
          {label}
        </StepLabel>
      </Step>
    ))}
  </Stepper>
)

const styles = (theme) => ({
  root: {
    padding: 0,
    marginTop: '-9px',  
  },
  alternativeLabel: {
    marginTop: '0px !important',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      fontSize: 10,
    },
  },
})

export default connect(
  (state) => ({ activeStep: state.view.stepper }),
  null,
)(withStyles(styles)(StepperComponent))
